export const DiningOptionComponent = {
    template: `
    <feature-flag-wrapper flag="oo-ab-testing">
        <flag-off><dining-option-default></dining-option-default></flag-off>
        <flag-on>
            <experiment ng-if="!$ctrl.loading" split-name="dining-option-selector" attributes="$ctrl.cartDisplay">
                <treatment treatment-key="TreatmentA" default>
                    <dining-option-default></dining-option-default>
                </treatment>
                <treatment treatment-key="TreatmentB">
                    <span c-type="title-md-accent">{{$ctrl.message()}}</span>
                </treatment>
                <treatment treatment-key="TreatmentC">
                    <dining-option-variant></dining-option-variant>
                </treatment>
                <treatment treatment-key="TreatmentD">
                    <dining-option-default></dining-option-variant>
                </treatment>
            </experiment>
        </flag-on>
    </feature-flag-wrapper>
   `,
    controller: class {
        constructor(cartDisplayService, ORDER_TYPES) {
            'ngInject';
            this.cartDisplayService = cartDisplayService;
            this.ORDER_TYPES = ORDER_TYPES;
            this.loading = true;

            cartDisplayService.getDisplayData()
                .finally(() => {
                    this.loading = false;
                    this.cartDisplay = this.cartDisplayService.displayData;
                });
        }

        message() {
            const type = this.cartDisplay.enableDelivery ? 'delivery' : 'pickup';
            return `Order for ${type}`;
        }
    }
};
